import { FC, ReactNode, useEffect } from 'react';
import './MasterPage.scss';
import { Container } from 'react-bootstrap';
import Navbar from '../../components/Navbar/Navbar';
// import Sidebar from '../../components/Sidebar/Sidebar';
import GenerateDegradeMaskPages from '../../utils/GenerateDegradeMaskPages';
import { useStyle } from '../../providers/StyleProvider';
import { CompanyEnum } from '../../enums/Company/CompanyEnum';
import Footer from '../../components/Footer/Footer';
import Sidebar from '../../components/Sidebar/Sidebar';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';

interface MasterPageProps {
  title?: string;
  subtitle?: string;
  icon?: string;
  dataTestId?: string;
  heightClass?: string;
  footerFixed?: boolean;
  children?: ReactNode;
}

const MasterPage: FC<MasterPageProps> = ({
  title = "",
  subtitle = "",
  icon = "",
  dataTestId = '',
  heightClass = 'min-height-400',
  children
}) => {
  const { style, theme, hslColor, handlePalette } = useStyle();

  useEffect(() => {
    style?.colorPrimary && handlePalette(style.colorPrimary);
  }, [style]);

  return (
    <>
      <div className={`position-absolute w-100 ${heightClass} top-0 MasterPage`}>
        <div
          className="mask bg-degrade opacity-10"
          style={{ background: theme ? GenerateDegradeMaskPages(theme, hslColor, style?.id ?? CompanyEnum.BEVI) : '' }}
        />
      </div>

      <Sidebar />

      <Navbar title={title} subtitle={subtitle} icon={icon} />

      <main className="main-content position-relative border-radius-lg MasterPage" data-testid="MasterPage">
        <Breadcrumb />

        <Container fluid className="px-4 main-wrapper" data-testid={dataTestId}>
          <>{children}</>
        </Container>

        {/* <Footer fixed={footerFixed} inverse={footerInverse} /> */}
      </main>
    </>
  );
}

export default MasterPage;
